import type { ReactNode } from 'react';
import { DomainFilter } from './DomainFilter';
import { ModelFilter } from './ModelFilter';
import { TopicFilter } from './TopicFilter';
import { SourceFilter } from './SourceFilter';
import { TrackerAiTimePicker } from './TrackerAiTimePicker';
import { DateRangeFilter } from './DateRangeFilter';

export function PageFilterBar({
  showDate = true,
  showModels = true,
  showTopics = true,
  showDomains = true,
  showSources = false,
  /** Date on one side, filter dropdowns on the other (dashboard). */
  splitDateAndFilters = false,
  /** 'calendar' = just the range calendar (default). 'quick' = preset dropdown (today/7d/30d/...) next to the calendar. */
  dateVariant = 'calendar',
  actions,
  /** Renders after the domain dropdown, in the same chip row. */
  extra,
}: {
  showDate?: boolean;
  showModels?: boolean;
  showTopics?: boolean;
  showDomains?: boolean;
  showSources?: boolean;
  splitDateAndFilters?: boolean;
  dateVariant?: 'calendar' | 'quick';
  actions?: ReactNode;
  extra?: ReactNode;
}) {
  const dateControl = (
    <div className="d-flex flex-wrap align-items-center gap-2">
      {dateVariant === 'quick' && <DateRangeFilter />}
      <TrackerAiTimePicker />
    </div>
  );
  const filterDropdowns = (
    <div className="d-flex flex-wrap align-items-center gap-1">
      {showModels && <ModelFilter />}
      {showTopics && <TopicFilter />}
      {showDomains && <DomainFilter />}
      {extra}
      {showSources && <SourceFilter />}
    </div>
  );

  if (splitDateAndFilters) {
    // RTL flex: first item → visual right, last → visual left.
    // Put dropdowns first so they sit on the right; date stays on the left.
    return (
      <div className="d-flex flex-wrap align-items-center justify-content-between gap-2 w-100">
        {actions ? (
          <div className="d-flex flex-wrap align-items-center gap-2">{actions}</div>
        ) : null}
        {filterDropdowns}
        {showDate ? dateControl : null}
      </div>
    );
  }

  return (
    <div className="d-flex flex-wrap align-items-center gap-2">
      {actions ? (
        <div className="d-flex flex-wrap align-items-center gap-2">{actions}</div>
      ) : null}
      <div className="d-flex flex-wrap align-items-center gap-3 ms-auto">
        {filterDropdowns}
        {showDate ? dateControl : null}
      </div>
    </div>
  );
}

export { DateRangeFilter } from './DateRangeFilter';
export { DomainFilter } from './DomainFilter';
export { ModelFilter } from './ModelFilter';
export { TopicFilter } from './TopicFilter';
